/// <reference path="../../typings/browser.d.ts" />

namespace Application.Services {
    'use strict';

    import IUser = Models.IUser;
    import IUserGroup = Models.IUserGroup;

    export class UserGroupService {
        public static $name: string = "userGroupService";
        public static $inject: string[] = ['$q', 'backendService', 'userService'];

        private backendBaseUrl: string = window.backendUrl;
        private servicePath: string = 'flexauth/';
        private groupsUrl: string = this.backendBaseUrl + this.servicePath + 'groups/';

        constructor(private $q: ng.IQService,
                    private backendService: Services.BackendService,
                    private userService: Services.UserService) {
            // nothing to do
        }

        public findAll(): ng.IPromise<IUserGroup[]> {
            return this.backendService
                .get(this.groupsUrl)
                .then((response: ng.IHttpPromiseCallbackArg<IUserGroup[]>)  => {
                    return response.data;
                });
        }

        public findById(id: number): ng.IPromise<IUserGroup> {
            return this.backendService
                .get(this.groupsUrl + id)
                .then((response: ng.IHttpPromiseCallbackArg<IUserGroup>)  => {
                    return response.data;
                });
        }

        public findByName(name: string): ng.IPromise<IUserGroup> {
            return this.backendService
                .get(this.groupsUrl + 'search/findByName?name=' + name)
                .then((response: ng.IHttpPromiseCallbackArg<IUserGroup>)  => {
                    return response.data;
                });
        }

        public findByUserId(id: number): ng.IPromise<IUserGroup[]> {
            return this.backendService
                .get(this.backendBaseUrl + this.servicePath + 'users/' + id + '/groups')
                .then((response: ng.IHttpPromiseCallbackArg<IUserGroup[]>) => {
                    return response.data;
                });
        }

        public saveGroup(group: IUserGroup): ng.IPromise<IUserGroup> {
            if (!group.id || group.id === undefined || group.id === '') {
                return this.createGroup(group);
            } else {
                return this.updateGroup(group);
            }
        }

        public createGroup(group: IUserGroup): ng.IPromise<IUserGroup> {
            return this.backendService
                .post(this.groupsUrl, {
                    name: group.name,
                    description: group.description,
                    organizationId: group.organizationId,
                    enabled: group.enabled,
                    created: group.created,
                })
                .then((result: ng.IHttpPromiseCallbackArg<IUserGroup>) => {
                    return result.data;
                 });
        }

        public updateGroup(group: IUserGroup): ng.IPromise<IUserGroup> {
            return this.backendService
                .put(this.groupsUrl + group.id, {
                    name: group.name,
                    description: group.description,
                    enabled: group.enabled,
                    created: group.created,
                })
                .then((result: ng.IHttpPromiseCallbackArg<IUserGroup>) => {
                    return result.data;
                 });
        }

        public addUserToGroup(userId: number, groupId: number, vnoId: number): ng.IPromise<IUser> {
            return this.backendService
                .post(`${this.backendBaseUrl}vnos/${vnoId}/groups/${groupId}/users`, userId)
                .then((response: ng.IHttpPromiseCallbackArg<IUser>) => {
                    return this.userService.refreshUser(userId).then(() => {
                        return response.data;
                    });
                });
        }

        public removeUserFromGroup(groupId: number, userId: number): ng.IPromise<IUser> {
            return this.backendService
                .delete(this.groupsUrl + groupId + '/users/' + userId)
                .then((response: ng.IHttpPromiseCallbackArg<IUser>) => {
                    return this.userService.refreshUser(userId).then(() => {
                        return response.data;
                    });
                });
        }

        public getUsersInGroup(groupId: number, vnoId: number): ng.IPromise<IUser[]> {
            return this.backendService
                // .get(this.groupsUrl + groupId + '/users')
                .get(`${this.backendBaseUrl}vnos/${vnoId}/groups/${groupId}/users`)
                .then((response: ng.IHttpPromiseCallbackArg<IUser[]>) => {
                    return response.data;
                });
        }

        public deleteGroup(group: Application.Models.IUserGroup): ng.IPromise<boolean> {
            return this.backendService
                .delete(this.groupsUrl + group.id)
                .then(() => {
                    return true;
                }).catch(() => {
                    return false;
                });
        }

        public generateDefaultGroup(vno: Models.IVno): IUserGroup {
            return new Models.UserGroup(-1, "All users " + vno.name, "All users in " + vno.name, true, vno.id, undefined, true);
        }
    }
}
